import Fluid from './Fluid';
import Square from './Square';

export default {
  Fluid,
  Square,
};

export const FluidAsset = Fluid;
export const SquareAsset = Square;
